// extracted by mini-css-extract-plugin
export default {"container":"VoucherScanner_container__fxTR+","info":"VoucherScanner_info__b22Qr","qr-content":"VoucherScanner_qr-content__Zjyjo","qr-frame":"VoucherScanner_qr-frame__e25RH"};